export function isEditableElement(element) {
  return Boolean(element && ['INPUT', 'TEXTAREA', 'SELECT'].includes(String(element.tagName || '').toUpperCase()));
}

export function isSoftKeyboardOpen({ focused = false, visualHeight = 0, layoutHeight = 0 } = {}) {
  return Boolean(focused && layoutHeight > 0 && visualHeight > 0 && visualHeight < layoutHeight * .86);
}

export function resolveKeyboardHeight({ focused = false, virtualHeight = 0, visualHeight = 0, layoutHeight = 0 } = {}) {
  if (!focused || layoutHeight <= 0) return 0;
  const detected = Math.max(0, Number(virtualHeight) || 0, layoutHeight - (Number(visualHeight) || layoutHeight));
  return detected >= 48 ? Math.min(layoutHeight * .72, detected) : Math.round(layoutHeight * .52);
}

export function calculateKeyboardScrollDelta({ rect, visibleTop = 0, visibleBottom = 0, padding = 24 } = {}) {
  if (!rect || visibleBottom <= visibleTop) return 0;
  if (rect.bottom > visibleBottom - padding) return Math.ceil(rect.bottom - (visibleBottom - padding));
  if (rect.top < visibleTop + padding) return Math.floor(rect.top - (visibleTop + padding));
  return 0;
}

export function calculateKeyboardShift({ rect, currentShift = 0, visualTop = 0, visualHeight = 0, padding = 24 } = {}) {
  if (!rect || visualHeight <= 0) return 0;
  const baseTop = Number(rect.top || 0) - currentShift;
  const baseBottom = Number(rect.bottom || 0) - currentShift;
  const visibleTop = visualTop + padding;
  const visibleBottom = visualTop + visualHeight - padding;
  if (baseBottom > visibleBottom) return Math.round(visibleBottom - baseBottom);
  if (baseTop < visibleTop) return Math.round(visibleTop - baseTop);
  return 0;
}
